import React from 'react';

interface IProps {
  title?: string;
  content?: React.ReactNode | string;
  style?: React.CSSProperties;
  contentOnNewLine?: boolean;
}

const SubHeader = (props: IProps) => {
  const { title, content, style, contentOnNewLine = false } = props;
  return (
    <div style={{ wordWrap: 'break-word', ...style }}>
      <h5>
        <span style={{ color: 'rgba(255, 255, 255, 0.6)' }}>{title}:</span>
        {content && (
          <span
            style={{
              paddingLeft: contentOnNewLine ? 0 : '8px',
              display: contentOnNewLine ? 'block' : 'inline',
              paddingTop: contentOnNewLine ? '4px' : 0,
            }}
          >
            {content}
          </span>
        )}
      </h5>
    </div>
  );
};

export default SubHeader;
